/* RehaComfort: Kopfbereich – Produkte-Menue oeffnet sich beim Darueberfahren (ab 990px) */
(function(){
  var mq=window.matchMedia('(min-width: 990px)');
  function init(){
    document.querySelectorAll('.header__inline-menu details').forEach(function(d){
      if(d.dataset.rcHover) return; d.dataset.rcHover='1';
      var t;
      d.addEventListener('mouseenter',function(){ if(!mq.matches) return; clearTimeout(t); if(!d.open) d.open=true; });
      d.addEventListener('mouseleave',function(){ if(!mq.matches) return; clearTimeout(t); t=setTimeout(function(){ if(d.open) d.open=false; },150); });
    });
  }
  /* Kompakter Kopf beim Scrollen: Hamburger klappt die Menuezeile aus/ein (kein Seitenmenue) */
  document.addEventListener('click',function(e){
    if(!mq.matches) return;
    var sum=e.target.closest('header-drawer summary'); if(!sum) return;
    var sec=sum.closest('.section-header'); if(!sec||!sec.classList.contains('scrolled-past-header')) return;
    e.preventDefault(); e.stopPropagation();
    sec.classList.toggle('rc-nav-open');
  },true);
  window.addEventListener('scroll',function(){
    var sec=document.querySelector('.section-header.rc-nav-open');
    if(sec&&!sec.classList.contains('scrolled-past-header')) sec.classList.remove('rc-nav-open');
  },{passive:true});
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
